import { useSelector } from 'react-redux';
import { LocalReportsState } from '../../redux/localReports/localReports.proptype';
import { selectLocalReportsData } from '../../selectors';

export const useLocalReportsData = (): LocalReportsState => {
  const localReportsData = useSelector(selectLocalReportsData);

  return localReportsData;
};
